import { toOptions } from '@/utils'
import { Input } from '@material-tailwind/react'
import { useFormikContext } from 'formik'
import { useMemo, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import CustomSelect from '@/shared/components/custom-select'
import { createSearchParams } from 'react-router-dom'
import { useGetCitiesQuery } from '@/store/services/city.service'

export const AddressForm = ({ required = false }) => {
  const { values, setFieldValue } = useFormikContext()
  const { t } = useTranslation()
  const { data: cities = [], isLoading: isLoadingCities } = useGetCitiesQuery()
  const {
    data: [currentCity = {}] = [],
    isSuccess: isSuccessCurrentCity
  } = useGetCitiesQuery(createSearchParams({ state_id: values?.address_attributes?.state_id }).toString(), { skip: !values?.address_attributes?.state_id })

  const [selectedCity, setSelectedCity] = useState([])
  const [stateOptions, setStateOptions] = useState([])

  const cityOptions = useMemo(() => {
    return toOptions({ data: cities })
  }, [cities])

  useEffect(() => {
    if (!selectedCity.value) return

    setStateOptions(toOptions({ data: selectedCity.resource.states }))
  }, [selectedCity])

  useEffect(() => {
    if (!isSuccessCurrentCity) return

    setSelectedCity(toOptions({ data: [currentCity] })[0])
  }, [isSuccessCurrentCity])

  return (
    <>
      <CustomSelect
        required={required}
        placeholder={t('city.one')}
        options={cityOptions}
        onChange={setSelectedCity}
        value={selectedCity}
        isLoading={isLoadingCities}
      />

      <CustomSelect
        required={required}
        placeholder={t('state.one')}
        isDisabled={!selectedCity.value}
        options={stateOptions}
        name='address_attributes.state_id'
        value={stateOptions.find(({ value: stateId }) => stateId === values?.address_attributes?.state_id)}
        onChange={({ value }) => setFieldValue('address_attributes.state_id', value)}
      />

      <Input
        required={required}
        label={t('street.withNumber')}
        name='address_attributes.street'
        value={values?.address_attributes?.street}
        onChange={({ target: { value } }) => setFieldValue('address_attributes.street', value)}
      />
    </>
  )
}
